import { createContext, useState } from 'react';
import styles from './../../../css/StaffMgmt.module.css';
import titleStyle from './../../../css/SectionTitle.module.css';
import { Routes, Route, } from "react-router-dom";
import PageNotFound from '../../404/PageNotFound';
import CreateInst from './CreateInst';
import ViewInstitutions from './ViewInstitutions';
import Menu from '../../../components/Menu';

export const staffContext = createContext();
export const EditContext = createContext();

const Institution = () => {
    const [title, setTitle] = useState('');
    const [view, setView] = useState();
    const [allInst, setAllInst] = useState([]);
    const [editInst, setEditInst] = useState({});

    return (
        <staffContext.Provider value={{ view, setView }}>
            <div className={`${styles.baseView}`} style={{ display: 'flex', flexWrap: 'wrap' }}>
                <h1 className={`${styles.title}`}>Institution Management</h1>
                <div className={`${styles.subView}`}>
                    <div className={titleStyle.sectionTitle}>
                        <h3 className={titleStyle.h3}>
                            {title}
                        </h3>
                        <Menu options={[
                            {label:'Create Institution',path:"create-institution",onClick:()=>setEditInst({})},
                            {label:'View Institution',path:"view-institution",onClick:()=>setEditInst({})}
                        ]} />
                    </div>
                    <EditContext.Provider value={{ editInst, setEditInst, allInst, setAllInst, }}>
                        <Routes>
                            <Route path='*' element={<ViewInstitutions setTitle={setTitle} />} />
                            <Route path='/create-institution' element={<CreateInst seTTitle={setTitle} />} />
                            <Route path='/view-institution' element={<ViewInstitutions setTitle={setTitle} />} />
                            <Route path="/*" element={<PageNotFound />} />
                        </Routes>
                    </EditContext.Provider>
                </div>
            </div>
        </staffContext.Provider>
    );
};

export default Institution;